import type { SxProps, Theme } from '@mui/material';

export const titleSx: SxProps<Theme> = { fontSize: '2rem', fontWeight: 700, lineHeight: 1.25 };

export const bodySx: SxProps<Theme> = {
  typography: 'body1',
  lineHeight: 1.7,
  // Long URLs and email addresses would otherwise push the page wider than a phone screen.
  overflowWrap: 'break-word',
  '& h2': { typography: 'h5', fontWeight: 600, mt: 4, mb: 1.5 },
  '& h3': { typography: 'h6', fontWeight: 600, mt: 3, mb: 1 },
  // Documents saved by the portal's general editor carry an inline zero margin on paragraphs.
  '& p': { marginBlock: '0.75em !important' },
  '& ul, & ol': { pl: 3, my: 1.5 },
  '& a': { color: 'primary.main' },
  '& table': { width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse', my: 2 },
  '& th, & td': {
    border: (theme) => `1px solid ${theme.palette.divider}`,
    px: 1.5,
    py: 1,
    textAlign: 'left',
    verticalAlign: 'top',
    overflowWrap: 'anywhere',
  },
  '& th': { fontWeight: 600, bgcolor: 'action.hover' },
  '& th p, & td p': { marginBlock: '0 !important' },
};
